<template>
  <section class="w-100 bg-50 pb-5" style="margin-top: -15px">
    <!-- differentials -->
    <differentials />

    <!-- content -->
    <b-container class="pb-5">
      <b-row class="display-block">
        <b-col md="0" class="text-white border-top-white pt-3">
          <!-- title -->
          <h1 class="font-weight-light mb-4 md-0 pl-3">
            Porque vendemos em
            <b>40 minutos?</b>
          </h1>
        </b-col>
        <!-- content -->
        <b-col md="6" class="text-white">
          <p class="font-weight-light mb-3 md-5">
            Na
            <b>VAAPTY</b>, você conta com a
            <b>melhor plataforma de vendas</b> do mercado automotivo.
          </p>
          <p class="font-weight-light mb-3 md-5">
            Temos
            <b>6.000 compradores</b> prontos para disputar o seu veículo, e uma
            <b>equipe especializada</b> com experiência de mais de 12 anos em vendas de automóveis. É por isso que vendemos tão rápido.
          </p>
          <p class="font-weight-light md-5">
            Agora você não precisa se preocupar quando receberá uma boa oferta.
            <b>Na VAAPTY seu carro tem hora e data para ser vendido.</b>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
// all
import Differentials from "@/components/Differentials";

export default {
  components: {
    differentials: Differentials,
  },
};
</script>

<style lang="scss" scoped>
h5 {
  margin-bottom: 0 !important;
}

.bg-50 {
  background-image: url("./../../assets/images/home/50min.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

@media (min-width: 767px) {
  .display-block {
    display: block;
  }
}
</style>
